import {API_URL, API_URL_V2} from "../config";
import { ConflictError, UnauthorizedError } from "../errors/http_errors";

export async function fetchData( input: RequestInfo, init?: RequestInit, versionAPI:number = 1) {
  const baseURL = versionAPI === 2 ? API_URL_V2 : API_URL;
  const response = await fetch(baseURL + input, init);

  if (response.ok) {
    return response;
  } else {
    const errorBody = await response.json();
    const errorMessage = errorBody.detail;
    if (response.status === 401) {
      throw new UnauthorizedError(errorMessage);
    } else if (response.status === 409) {
      throw new ConflictError(errorMessage);
    } else {
      throw Error("Request failed with status: " + response.status + ". message: " + errorMessage);
    }
  }
}
